import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    consumerGroupsGet,
    consumerGroupsGetById,
    consumerGroupInsert,
    consumerGroupUpdate,
    consumerGroupDelete
} from "api/menu/master-files/consumer-groups/requests";

export const FETCH_CONSUMER_GROUP_SUCCESS = "FETCH_CONSUMER_GROUP_SUCCESS";
export const FETCH_CONSUMER_GROUP_ITEM_SUCCESS = "FETCH_CONSUMER_GROUP_ITEM_SUCCESS";

export const CONSUMER_GROUP_REQUEST_LOADING = "CONSUMER_GROUP_REQUEST_LOADING";
export const CONSUMER_GROUP_REQUEST_ERRORS = "CONSUMER_GROUP_REQUEST_ERRORS";

export const setLoading = () => ({
    type: CONSUMER_GROUP_REQUEST_LOADING
});

export const fetchConsumerGroups = (includeInactive = true) => dispatch => {
    dispatch(setLoading());
    consumerGroupsGet(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_CONSUMER_GROUP_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, CONSUMER_GROUP_REQUEST_ERRORS));
        });
};

export const fetchConsumerGroupById = (id) => dispatch => {
    dispatch(setLoading());
    consumerGroupsGetById(id)
        .then(response => {
            dispatch({
                type: FETCH_CONSUMER_GROUP_ITEM_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, CONSUMER_GROUP_REQUEST_ERRORS));
        });
};

export const insertConsumerGroup = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    consumerGroupInsert(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Consumer Group "${data.code}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateConsumerGroup = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    consumerGroupUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Consumer Group "${data.code}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteConsumerGroup = (id, code, callback = false) => dispatch => {
    dispatch(setLoading());
    consumerGroupDelete(id)
        .then(() => {
            toast(`Consumer Group "${code}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, CONSUMER_GROUP_REQUEST_ERRORS));
        });
};

export const clearConsumerGroups = () => dispatch => {
    dispatch({
        type: FETCH_CONSUMER_GROUP_SUCCESS,
        payload: []
    });
};

export const clearConsumerGroupItem = () => dispatch => {
    dispatch({
        type: FETCH_CONSUMER_GROUP_ITEM_SUCCESS,
        payload: {}
    });
};
